var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{staticClass:"loading index-5 ma-0",attrs:{"color":"third","indeterminate":true,"active":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }